import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '@shared/hooks';
import { cn, RoutePaths } from '@shared/utils';
import { Footer } from '@widgets';
import { Button, Text } from '@shared/widgets';
import errorImg from '@assets/images/error-page.png';

export const ErrorPage = () => {
  const { t } = useTranslation('error');

  useDocumentTitle('Error');

  return (
    <>
      <main className={cn('flex flex-auto flex-col px-4 py-12', 'max-md:py-8')}>
        <section className='m-auto flex w-full max-w-[510px] flex-col items-center text-center'>
          <img className='mb-6 h-auto w-full max-w-[510px]' src={errorImg} alt='error' />
          <Text className={cn('mb-6', 'max-md:mb-4 max-md:text-3xl')} center size='5xl'>
            {t('title')}
          </Text>
          <Text className='max-md:text-base' center weight='light' size='lg'>
            {t('description')}
          </Text>
          <Button className={cn('mt-12', 'max-md:mt-8')} fullWidth color='primary' to={RoutePaths.dashboard.onNavigate()}>
            {t('buttons.goBack')}
          </Button>
        </section>
      </main>
      <Footer />
    </>
  );
};
